import React from 'react';
import './AreaMap.css';

const AreaMap = () => (
  <div className="container area-map-page">
    <section className="about-preamble">
      <h1>Area Map</h1>
      <p>
        The CWARA boundary covers the streets around Carlisle Avenue and Waverley Road.
        Use the map to explore the boundary, see nearby schools, health services,
        community venues, parks and shops, and find local events. Toggle layers on and
        off using the panel in the top-right of the map.
      </p>
    </section>

    <section className="about-section">
      <div className="map-embed">
        <iframe
          src={`${process.env.PUBLIC_URL}/area-map/index.html`}
          title="CWARA area &amp; boundary map"
          loading="lazy"
          allowFullScreen
        />
      </div>
      <p className="map-note">
        Points of interest are drawn from OpenStreetMap. Polling-station locations are
        indicative only &mdash; please confirm your station with St&nbsp;Albans City &amp;
        District Council. Events you add are saved in your own browser.
      </p>
    </section>
  </div>
);

export default AreaMap;
